import type { EditorLayer, LayerRenderPlane } from '../types/levelEditor';

export const DEFAULT_LAYER_RENDER_PLANE: LayerRenderPlane = 'background';

export const normalizeLayerRenderPlane = (value: unknown): LayerRenderPlane =>
  value === 'foreground' ? 'foreground' : DEFAULT_LAYER_RENDER_PLANE;

export const resolveLayerRenderPlane = (
  layer: Pick<EditorLayer, 'renderPlane'>,
): LayerRenderPlane => normalizeLayerRenderPlane(layer.renderPlane);
